import React, { useState, useEffect } from "react";
import axios from "axios";

const JobPopup = ({ job, onClose }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg p-8 max-w-2xl w-full max-h-[90vh] overflow-y-auto">
         <h2 className="text-2xl font-bold mb-4">{job.title}</h2>
        <p className="mb-2"><strong>Company:</strong> {job.company_name}</p>
        <p className="mb-2"><strong>Contract</strong> {job.job_tenure}</p>
        <p className="mb-2"><strong>Type:</strong> {job.job_type}</p>
        <p className="mb-2"><strong>Salary:</strong> {job.salary_min && job.salary_max ? 
          `Rp ${job.salary_min.toLocaleString()} - Rp ${job.salary_max.toLocaleString()}` : 
          'Not specified'}
        </p>
        <p className="mb-4"><strong>Description:</strong> {job.job_description}</p>
        <p className="mb-4"><strong>Qualifications:</strong> {job.job_qualification}</p>
        <div className="flex items-center justify-center bg-gray-20 p-4 rounded-lg">
            <img src={job.company_image_url} alt="icon" className="w-24 h-24 rounded" />
            <p className="ml-2"></p>
          </div>
        <div className="flex justify-end">

        <button 
            className="px-4 py-2 mx-2 bg-blue-800 text-white rounded hover:bg-sky-900">
            Apply
          </button> 
          <button 
            onClick={onClose}
            className="px-4 py-2 bg-gray-800 text-white rounded hover:bg-gray-700">
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

const Vacancy = () => {
    const [Lowongan, setLowongan] = useState([]);
    const [fetchStatus, setFetchStatus] = useState(true);
    const [selectedJob, setSelectedJob] = useState(null);
    
    useEffect(() => {
        if (fetchStatus){
            axios.get('https://final-project-api-alpha.vercel.app/api/jobs')
            .then((res) => {
                setLowongan(res.data);
            })
            .catch((err) => {
                console.log("Data Tidak Tampil")
            })
            setFetchStatus(false)
        }
    },[fetchStatus]);

    const handleApply = (job) => {
        setSelectedJob(job);
    };

    return(
        <>
           <section className="bg-white p-8">
             <div className="container mx-auto mt-10">
                <h1 className="text-3xl font-bold mb-6">Lowongan Pekerjaan</h1>

                <div className="container mx-auto flex flex-wrap gap-10 items-start justify-start">
                {Lowongan.map((job) => (
                    <div key={job.id} className="mt-10 h-auto flex max-w-xl bg-white shadow-lg rounded-lg overflow-hidden">
                        <img src={job.company_image_url || ""}
                            alt={job.company_name}
                            className="w-1/3 object-cover bg-center" />
                        <div className="w-2/3 p-4">
                            <h1 className="text-gray-900 font-bold text-2xl mb-2">
                                {job.title}
                            </h1>
                            <small>{job.company_name}</small>
                            <p className="mt-2 text-gray-600 text-sm">
                                {job.job_description}
                            </p>
                            <div className="mt-2 text-gray-500">
                                <span className="mr-2">{job.job_tenure}</span>
                                <span className="mr-2">{job.job_type}</span>
                            </div>
                            <div className="flex items-center justify-between mt-3">
                                <h1 className="text-gray-700 font-bold text-xl">
                                    {job.salary_min && job.salary_max ? 
                                        `Rp ${job.salary_min.toLocaleString()} - Rp ${job.salary_max.toLocaleString()}` : 
                                        'Gaji tidak dicantumkan'}
                                </h1>
                                <button 
                                  onClick={() => handleApply(job)}
                                  className="px-3 py-2 bg-blue-500 text-white text-xs font-bold uppercase rounded hover:bg-sky-700"
                                >
                                  Apply 
                                </button>
                            </div>
                        </div>
                    </div>
                ))}
                </div>
            </div>
        </section>

        {selectedJob && (
          <JobPopup job={selectedJob} onClose={() => setSelectedJob(null)} />
        )}
        </>
    )
}

export default Vacancy;